import React from 'react';

export const CTA = () => {
  return (
    <div className="skydive-cta-section">
      <p className="skydive-cta-section-text">
        Over 1 million people worldwide have experienced the unforgettable
        thrill of dynamic flight with our FPV simulator, FPV.SkyDive.
      </p>
      <div className="dreamX__discover--button">
        <a
          href="https://store.steampowered.com/app/1278060/FPV_SkyDive__FPV_Drone_Simulator/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--primary btn--med"
          onMouseDown={event => event.preventDefault()}
        >
          EXPERIENCE THE THRILL
        </a>
      </div>
    </div>
  );
};
